import React, { useEffect, useState } from "react";
import { StyleSheet } from "react-native";
import { Button } from "~/components/Button";
import { Modal } from "~/components/Modal";
import { Spacer } from "~/components/Spacer";
import { Text } from "~/components/Text";
import { View } from "~/components/View";
import { styleConstants } from "~/style/styleConstants";
import { GenderFemale, GenderMale, GenderOther } from "../gender-icons";
import type { MediaStream } from "react-native-webrtc";

// We show this overlay only on iOS
export function OtherUserOverlay({
  onDecline,
  remoteStream,
  otherUserDetails,
}: {
  onDecline: () => void;
  remoteStream: MediaStream;
  otherUserDetails: {
    name: string;
    age: number;
    sex: "male" | "female" | "other";
  };
}) {
  // Apple has a strict policy on features such as chat roulette
  // They require us to show a prompt to the user before they connect
  // Prompt should give them abiliy to accept or decline the connection
  const [isOverlayVisible, setIsOverlayVisible] = useState(true);

  useEffect(() => {
    if (isOverlayVisible) {
      const audioTrackList = remoteStream.getAudioTracks();
      for (const track of audioTrackList) {
        track.enabled = false;
      }
    } else {
      const audioTrackList = remoteStream.getAudioTracks();
      for (const track of audioTrackList) {
        track.enabled = true;
      }
    }
  }, [isOverlayVisible, remoteStream]);

  if (!isOverlayVisible) return null;

  return (
    <Modal>
      <View
        flex
        centerContent
        style={style.background}
        paddingHorizontalExtraLarge
      >
        <View
          colorBackgroundBackdropWhite
          borderRadiusMedium
          style={style.grayBorder}
        >
          {otherUserDetails.sex === "male" ? (
            <GenderMale />
          ) : otherUserDetails.sex === "female" ? (
            <GenderFemale />
          ) : otherUserDetails.sex === "other" ? (
            <GenderOther />
          ) : null}
        </View>
        <Spacer />
        <Text colorLight sizeExtraLarge weightExtraBold>
          {
            // eslint-disable-next-line formatjs/no-literal-string-in-jsx
            `${otherUserDetails.name}, ${otherUserDetails.age}`
          }
        </Text>
        <Spacer />
        <View flexDirectionRow style={style.gapLarge}>
          <Button
            large
            flex
            colorDanger
            outline
            title={intl.formatMessage({
              defaultMessage: "Decline",
              id: "7aokMb",
              description: "Text for decline button in overlay",
            })}
            onPress={onDecline}
          />
          <Button
            large
            flex
            colorSuccess
            title={intl.formatMessage({
              defaultMessage: "Accept",
              id: "D7ViN1",
              description: "Text for accept button in overlay",
            })}
            onPress={() => {
              setIsOverlayVisible(false);
            }}
          />
        </View>
      </View>
    </Modal>
  );
}

const style = StyleSheet.create({
  background: { backgroundColor: "rgba(0, 0, 0, 0.95)" },
  grayBorder: {
    borderWidth: 1,
    borderColor: styleConstants.colorBackgroundGray,
  },
  gapLarge: { gap: styleConstants.spacingLarge },
});
